<template>
    <PerspectiveCircles v-if="bootstrapIconClass === undefined" class="size-4 shrink-0" />
    <i v-else class="bi" :class="bootstrapIconClass" aria-hidden="true"></i>
</template>

<script setup lang="ts">
import PerspectiveCircles from "~vue/components/PerspectiveCircles.vue";
import { EVIDENCE_ICON_CLASSES, type EvidenceSourceType } from "~vue/Labs/evidence";
import { computed } from "vue";

const props = defineProps<{ kind: EvidenceSourceType }>();

const bootstrapIconClass = computed(() => (props.kind === "perspective" ? undefined : EVIDENCE_ICON_CLASSES[props.kind]));
</script>
